import React, { useEffect } from "react";
import NewsLetter from "web/pages/public/landing-page/NewsRoom/NewsLetter";
import AOS from "aos";

import {
  Container,
  Wrapper,
} from "web/pages/public/landing-page/NewsRoom/IndustryCatchUp/IndustryCatchUpStyled";

const IndustryCatchUp = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
    });
  }, []);
  return (
    <Container data-aos="fade-up" data-aos-delay="400">
      <Wrapper>
        <h4 className="news-room-heading">
          The entire industry is talking about<br></br> The launch of
          PalletTrader.
        </h4>
        <h5 className="news-room-sub-heading">
        A Revolutionary online marketplace for buying and selling pallets
          made its debut in October, and the supply chain industry has been
          buzzing ever since. We’ve collected a few of the early highlights
          here.
        </h5>
        <NewsLetter />
      </Wrapper>
    </Container>
  );
};

export default IndustryCatchUp;
